import { Navigate, useLocation } from 'react-router-dom';

import { canManageOAuthClients } from '@/modules/auth/domain/access/roleAccess';
import { LoadingScreen } from '@/shared/components';
import { APP_ROUTES } from '@/shared/constants';

import { useAuthStore, useIsAuthInitialized } from '../../application/store';

import type { ReactNode } from 'react';

interface RoleGuardProps {
  children: ReactNode;
  canAccess?: (role: string | null | undefined) => boolean;
}

export function RoleGuard({ children, canAccess }: RoleGuardProps) {
  const isInitialized = useIsAuthInitialized();
  const user = useAuthStore(state => state.user);
  const location = useLocation();
  const hasAccess = (canAccess ?? (role => canManageOAuthClients(role ? { role } : null)))(user?.role);

  if (!isInitialized) return <LoadingScreen />;
  if (!hasAccess) return <Navigate to={APP_ROUTES.DASHBOARD} state={{ forbiddenFrom: location.pathname }} replace />;

  return <>{children}</>;
}
